$(document).ready(function() {
    var href = window.location.href;
    var lang = $('html').attr('lang').substring(0,2);

    // Preselect EPDM region based on language
    const langMap = {
        'nl': '1.33',
        'fr': '1.5',
        'es': '2',
        'pt': '2',
        'it': '2',
        'de': '1.33',
        'da': '1.2',
        'en': '1.2'
    };
    const targetValue = langMap[lang];
    if (targetValue && $('#land option[value="' + targetValue + '"]').length) {
        $('#land').val(targetValue);
    }

    var epdmPrd = [
        "ZVZX1015-P",
        "ZVZX1320-S",
        "ZVZX1011-P",
        "ZVZX1211-P",
        "ZVZX1222-P",
        "ZVZX1231-P",
        "ZVZX1241-P",
        "ZVZX1310-P1M",
        "ZVZX1310-60S",
        "ZWPX2184-P",
        "ZWPX2197-S",
        "ZWPX2180-P",
        "ZWPX2185-P",
        "ZWPX2194-P",
        "ZWPX2196-S",
        "ZWPX2182-P",
        "ZWPX2195-S",
        "ZVZX2194-P",
        "ZVZX2196-P",
        "ZVZX2180-P",
        "ZVZX2185-P"

    ];
    var isEPDMPrdPage =
        href.indexOf("/products/") > -1
        && epdmPrd.indexOf($("span.variant-sku").text()) > -1;
    var isLandingPage = href.indexOf("/pages/") > -1 && $(".elfsight-app-0c9e298e-ebc4-4e51-b924-e287d5c9c6c0").length;

    if (isEPDMPrdPage) {

        var prepareCalcAwareness = function (waitElement) {
            waitForElementToDisplay(waitElement,
                function() {
                    if ($("[class^=ButtonBase__Ellipsis-sc]").length) {

                        $("[class^=ButtonBase__Ellipsis-sc]").on("click", function(event) {
                            event.preventDefault();
                            var count = $("[class^=animated-number__Content-sc]").text().split("m²")[0];
                            var sku = $("span.variant-sku").text();
                            switch(sku) {
                                case "ZVZX1011-P":
                                    count = Math.ceil(count / 2);
                                    break;
                                case "ZVZX1211-P":
                                    count = Math.ceil(count / 3);
                                    break;
                                case "ZVZX1222-P":
                                    count = Math.ceil(count / 4);
                                    break;
                                case "ZVZX1231-P":
                                    count = Math.ceil(count / 5);
                                    break;
                                case "ZVZX1241-P":
                                    count = Math.ceil(count / 6);
                                    break;
                                case "ZVZX1015-P":
                                    count = Math.ceil(count / 0.66);
                                    break;
                                case "ZVZX1215-P":
                                    count = Math.ceil(count / 0.99);
                                    break;
                                case "ZVZX1225-P":
                                    count = Math.ceil(count / 1.32);
                                    break;
                                case "ZVZX1235-P":
                                    count = Math.ceil(count / 1.65);
                                    break;
                                case "ZVZX1245-P":
                                    count = Math.ceil(count / 1.98);
                                    break;
                                case "ZVZX1310-P1M":
                                    count = Math.ceil(count / 0.15);
                                    break;
                                case "ZVZX1310-60S":
                                    count = Math.ceil(count / 9);
                                    break;

                            }
                            $(".price-per-item__container .quantity__input").val(count);
                            document.querySelector(".product-form__input.product-form__quantity")?.scrollIntoView({behavior: "smooth", block: "center"});
                            setTimeout(() => {
                                const harmoSelect = document.querySelector(".quantity__input");
                                if (harmoSelect) {
                                    harmoSelect.dispatchEvent(new Event("change", {bubbles: true}));
                                    // Highlight with gold pulse (fade in/out over 2s)
                                    harmoSelect.style.transition = 'none';  // Reset any existing transitions
                                    harmoSelect.classList.add('epdm-highlight');
                                    // Auto-remove after 2s
                                    setTimeout(() => {
                                        harmoSelect.classList.remove('epdm-highlight');
                                    }, 2000);
                                }
                            }, 1000);
                        });
                        $("[class^=EmbedRoot__Root-sc] > a").remove();
                    }
                },1000,15000
            );
        };
        prepareCalcAwareness(".elfsight-app-0c9e298e-ebc4-4e51-b924-e287d5c9c6c0 button");

        // in case a product is not directly an EPDM solar panel but an accessory, we prepare the EPDm calculator in a feasible solar panel upsell
        var prepareEPDMupsell = function (waitElement) {
            waitForElementToDisplay(waitElement,
                function() {
                    $(".lb-spc-details-name").each( function() {
                        text = $(this).text().trim();
                        if (text.indexOf('EPDM')!== -1 && text.indexOf('UV')!== -1) {
                            switch(lang) {
                                case "nl":
                                    var label = " Berekening van de benodigde oppervlakte";
                                    break;
                                case "de":
                                    var label = " Berechnung benötigten Oberfläche";
                                    break;
                                case "fr":
                                    var label = " Calculation de la surface requise";
                                    break;
                                case "es":
                                    var label = " Cálculo de la superficie requeridae";
                                    break;
                                case "pt":
                                    var label = " Cálculo da área de superfície necessária";
                                    break;
                                case "it":
                                    var label = " Calcolo della superficie richiesta";
                                    break;
                                case "da":
                                    var label = " Beregning af det nødvendige overfladeareal";
                                    break;
                                case "en":
                                    var label = " Calculation of the required surface area";
                                    break;
                            }
                            if (loadEpdmCalculator('.lb-spc-cont', label)) {
                                $("#calculator-accordion").accordion();
                                $("#calculator-accordion").accordion("enable");
                                $("#calculator-accordion").accordion({collapsible: true, active: false});
                                $("#calculator-accordion").css({"display": "block"});
                                $(this).closest(".lb-spc-cont").addClass("epdm-upsell");
                            }
                        }
                    });
                },1000,9000
            );
        };
        prepareEPDMupsell(".lb-upsell-ppa-card-cont");

        // Change the amount label to surface in sqm
        if ($("span.variant-sku").text() === "ZVZX1320-S") {
            var opp = "Oppervlakte in m²";
            if (lang !== "nl") {
                switch (lang) {
                    case "fr":
                        opp = "Superficie en m²";
                        break;
                    case "pt":
                        opp = "Área em m²";
                        break;
                    case "es":
                        opp = "Superficie en m²";
                        break;
                    case "de":
                        opp = "Fläche in m²";
                        break; 
                    case "da":
                        opp = "Areal i m²";
                        break;
                    case "it":
                        opp = "Superficie in m²";
                        break;
                    case "en":
                        opp = "Area in m²";
                        break;
                }
            }
            $(".product-form__input.product-form__quantity label").text(opp);
        }
    }

    if (isEPDMPrdPage) {
        try {
            $("#calculator-accordion").css({"display": "none"});
            $("#calculator-accordion").accordion();
            $("#calculator-accordion").accordion("enable");
            $("#calculator-accordion").accordion({collapsible: true, active: false});
            $("#calculator-accordion").css({"display": "block"});
        } catch (e) {
            console.log("accordion function is not defined");
        }
    }

    if (lang !== "nl" && (isLandingPage || isEPDMPrdPage)) {
        // translate literals
        var literals = {
            "Oppervlakte in m²": {
                fr: "Superficie en m²",
                pt: "Área em m²",
                de: "Fläche in m²",
                es: "Superficie en m²",
                it: "Superficie in m²",
                da: "Areal i m²",
                en: "Surface area in m²"
            },
            "Beschrijf de totale hoogte x breedte van uw gewenste EPDM zonnecollector. Geef als breedte steeds een veelvoud van 33.3 cm.": {
                fr: "Décrivez la hauteur x la largeur totale du capteur solaire EPDM souhaité. Spécifiez toujours un multiple de 33,3 cm pour la largeur.",
                pt: "Descreva a altura x largura total do coletor solar de EPDM pretendido. Especifique sempre um múltiplo de 33,3 cm para a largura.",
                de: "Beschreiben Sie die Gesamthöhe x Breite Ihres gewünschten EPDM-Solarkollektors. Geben Sie bei der Breite immer ein Vielfaches von 33,3 cm an.",
                es: "Describe la altura x ancho total del colector solar EPDM deseado. Especifique siempre un múltiplo de 33,3 cm para el ancho.",
                it: "Descrivi l'altezza x larghezza totale del collettore solare EPDM desiderato. Indica sempre la larghezza come multiplo di 33,3 cm.",
                da: "Beskriv den samlede højde x bredde på den ønskede EPDM-solkollektor. Angiv altid bredden som et multiplum af 33,3 cm.",
                en: "Describe the total height x width of your desired EPDM solar collector. Always specify the width as a multiple of 33.3 cm."
            },
            "Hoogte X Breedte EPDM installatie": {
                fr: "Installation EPDM hauteur x largeur *",
                pt: "Instalação de EPDM Altura X Largura *",
                de: "Höhe X Breite EPDM-Installation *",
                es: "Instalación de EPDM Alto X Ancho *",
                it: "Installazione EPDM altezza x larghezza *",
                da: "EPDM-installation højde x bredde *",
                en: "EPDM installation height x width *"
            }
        };
        const placeholderDict = {
            '##.## meter X ##.## meter': {
                fr: '##.## mètre X ##.## mètre',
                es: '##.## metro X ##.## metro',
                pt: '##.## metro X ##.## metro',
                it: '##.## metro X ##.## metro',
                de: '##.## Meter x ##.## Meter',
                da: '##.## meter x ##.## meter',
                en: '##.## meter x ##.## meter'
            }
        };

        var translateLiterals = function (waitElement, event) {
            waitForElementToDisplay(waitElement,
                function() {
                    var text = ""; var textInner ="";
                    var translation ="";
                    var sku = $("span.variant-sku").text();
                    if (sku === "ZVZX1320-S") {
                        $(".product-form__input.product-form__quantity label").each( function() {
                            text = $(this).text();
                            text = "Oppervlakte in m²";
                            try {
                                translation = literals[text][lang];
                            }
                            catch (err) {
                                //not found
                                translation = text;
                            }
                            $(this).text(translation);
                        });
                        $("custom-fields .field-description").each( function() {
                            text = $(this).text().trim();
                            try {
                                translation = literals[text][lang];
                            }
                            catch (err) {
                                //not found
                                translation = text;
                            }
                            $(this).text(translation);
                        });
                        $("custom-fields label").each( function() {
                            text = $(this).text().trim().slice(0, -2).trim();
                            try {
                                translation = literals[text][lang];
                            }
                            catch (err) {
                                //not found
                                translation = text;
                            }
                            $(this).text(translation);
                        });
                        // Update placeholder if field exists and translation available
                        const $heightField = $('#field-MBiibX93fYHiTcRjpy37M-1');
                        if ($heightField.length) {
                            const originalPH = $heightField.attr('placeholder');
                            if (placeholderDict[originalPH] && placeholderDict[originalPH][lang]) {
                                $heightField.attr('placeholder', placeholderDict[originalPH][lang]);
                            }
                        }
                    }
                },100, 15000
            );
        };
        translateLiterals(".ma-custom-field");


        var accHeader = document.getElementsByClassName("epdm-accordion-header");
        for (const key in accHeader) {
            if (accHeader.hasOwnProperty(key)) {
                accHeader[key].addEventListener("click", (evt) => translateLiterals(".form__Container-sc-de90c04-0"));
            }
        }
        var variantOpMaat = document.getElementById("template--23332797350236__main-1-0");
        if (variantOpMaat) {
            variantOpMaat.addEventListener("change", (evt) => translateLiterals(".form__Container-sc-de90c04-0"));
        }
        var variantLabel = document.querySelector('label[for="template--23332797350236__main-1-0"]');
        if (variantLabel) {
            variantLabel.addEventListener("click", (evt) => {
                translateLiterals(".ma-custom-field-group");
            });
        }
    }
    
    async function loadEpdmCalculator(targetId = '#calculator-container', label = ' Calculation of the required surface area') {
        try {     
            const response = await fetch('/?section_id=epdm-calculator');
            const fullHtml = await response.text();
            
            const parser = new DOMParser();
            const doc = parser.parseFromString(fullHtml, 'text/html');
            let calculatorHtml = doc.querySelector('#epdm-calculator')?.outerHTML || 
                                doc.querySelector('.calculator')?.outerHTML || '';
            
            const target = document.querySelector(targetId);
            if (target && calculatorHtml) {
            // ✅ SAFE: Create container first
            const accordion = document.createElement('div');
            accordion.id = 'calculator-accordion';
            accordion.style.display = 'none';
            target.appendChild(accordion);
            
            // ✅ SAFE HEADER (textContent avoids SVG quote issues)
            const header = document.createElement('h3');
            header.className = 'epdm-accordion-header';
            header.innerHTML = '<svg><!-- MINIMAL PLACEHOLDER --></svg>';  // Add SVG via next step
            
            const labelSpan = document.createElement('span');
            labelSpan.textContent = label;  // ✅ No escaping issues
            header.appendChild(labelSpan);
            
            accordion.appendChild(header);
            
            // ✅ ELF SIGHT DIV
            const elfsightDiv = document.createElement('div');
            elfsightDiv.className = 'elfsight-app-0c9e298e-ebc4-4e51-b924-e287d5c9c6c0';
            elfsightDiv.dataset.elfsightAppLazy = '';
            accordion.appendChild(elfsightDiv);
            
            // ✅ PARSE & APPEND CALCULATOR (SAFE)
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = calculatorHtml;
            while (tempDiv.firstChild) {
                accordion.appendChild(tempDiv.firstChild);
            }
            
            // ✅ ADD SVG AFTER (separate step)
            const svg1 = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg1.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            svg1.setAttribute('width', '40');
            svg1.setAttribute('height', '40');
            svg1.setAttribute('viewBox', '0 0 48 48');
            // Add paths via createElementNS
            const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path1.setAttribute('fill', '#cfd8dc');
            path1.setAttribute('d', 'M42,37c0,2.762-2.238,5-5,5H11c-2.762,0-5-2.238-5-5V11c0-2.762,2.238-5,5-5h26c2.762,0,5,2.238,5,5V37z');
            svg1.appendChild(path1);
            // Add other paths...
            header.insertBefore(svg1, labelSpan);
            
            setTimeout(() => {
                if (window.initCalculator) window.initCalculator();
            }, 200);
            
            return true;
            }
            return false;
        } catch (error) {
            console.log('EPDM calc load failed:', error);
            return false;
        }
    }
});

function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
    var startTimeInMs = Date.now();
    (function loopSearch() {
        if (document.querySelector(selector) != null) {
            callback();
            return;
        }
        else {
            setTimeout(function () {
                if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                    return;
                loopSearch();
            }, checkFrequencyInMs);
        }
    })();
}